/*
 * @Author: Wang Wenmao
 * @Date: 2023-08-18 17:44:56
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2023-08-18 17:44:57
 * @Description: ...
 */

import m from 'mitt';

export const mitt = m();
